const pcip17ScriptBaseUrl = document.currentScript?.src || window.location.href;

document.addEventListener("DOMContentLoaded", () => {
  const APIPPA_CALCULATOR_ID = "94f1f2f675184";
  const SHOPIFY_PRODUCT_ID = 8000949059632;

  const scriptBaseUrl = pcip17ScriptBaseUrl;
  const DEFAULT_MOCKUP = "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/iphone-17-pro-max-cosmic-orange-mockup.png?v=1781809531";
  const MOCKUP_FILES = {
    "Cosmic Orange": "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/iphone-17-pro-max-cosmic-orange-mockup.png?v=1781809531",
    "Deep Blue": "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/iphone-17-pro-max-deep-blue-mockup.png?v=1781809531",
    Silver: "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/iphone-17-pro-max-silver-mockup.png?v=1781809531",
  };

  const state = {
    size: null,
    uploadedImage: null,
    uploadedImageUrl: null,
    uploadedImageTransform: null,
    editedImage: null,
    iphonePreview: "Cosmic Orange",
    materialFinish: "Standard",
    enhanceImage: "No, Keep Image as is",
    onlineProof: "Yes",
    packSize: "Single",
    price: 0,
  };

  let designer = null;

  const PRICE_VARIANTS = {
    size: [
      { value: "IPhone 17 Pro", price: 16.99 },
      { value: "IPhone 17 Pro Max", price: 16.99 },
    ],
    materialFinish: [
      { value: "Standard", price: 0 },
      { value: "Holographic", price: 3 },
      { value: "Glitter", price: 5 },
    ],
    enhanceImage: [
      { value: "No, Keep Image as is", price: 0 },
      { value: "YES, Enhance Image Quality", price: 5 },
    ],
    onlineProof: [
      { value: "Yes", price: 0 },
      { value: "No", price: 0 },
    ],
  };

  const PACK_VARIANTS = [
    { value: "Single", qty: 1, discount: 0 },
    { value: "2 Pack", qty: 2, discount: 0 },
    { value: "3 Pack", qty: 3, discount: 0.05 },
    { value: "5 Pack", qty: 5, discount: 0.1 },
    { value: "10 Pack", qty: 10, discount: 0.2 },
  ];

  const ALLOWED_IMAGE_TYPES = [
    "image/jpeg",
    "image/jpg",
    "image/png",
    "image/webp",
    "image/svg+xml",
  ];

  function show(el) {
    if (el) el.style.display = "";
  }

  function hide(el) {
    if (el) el.style.display = "none";
  }

  function resolveAssetUrl(file) {
    if (!file) return "";
    if (/^(https?:|data:|blob:|\/)/i.test(file)) return file;
    try {
      return new URL(file, scriptBaseUrl).href;
    } catch (_err) {
      return file;
    }
  }

  function getMockupUrlFromOption(option) {
    if (!option) return "";

    const explicitUrl = option.dataset.mockupUrl || option.dataset.mockupSrc;
    if (explicitUrl) return explicitUrl;

    const dataMockup = option.dataset.mockup || "";
    if (/^(https?:|data:|blob:|\/)/i.test(dataMockup)) return dataMockup;

    const mappedUrl = MOCKUP_FILES[option.dataset.preview];
    if (/^(https?:|data:|blob:|\/)/i.test(mappedUrl || "")) return mappedUrl;

    const previewImg = option.querySelector("img");
    const thumbnailUrl =
      previewImg?.currentSrc ||
      previewImg?.src ||
      previewImg?.getAttribute("src") ||
      "";
    if (thumbnailUrl) return thumbnailUrl;

    return mappedUrl || dataMockup || DEFAULT_MOCKUP;
  }

  function getSelectedPreviewMockupUrl(previewName = state.iphonePreview) {
    const option = Array.from(
      document.querySelectorAll("#iphone-preview-variant .sticker-variant")
    ).find((item) => item.dataset.preview === previewName);

    return getMockupUrlFromOption(option) || MOCKUP_FILES[previewName] || DEFAULT_MOCKUP;
  }

  function animatePriceChange(targetElement, start, end, duration = 500) {
    if (!targetElement) return;
    let startTime = null;
    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      const currentValue = start + (end - start) * progress;
      targetElement.textContent = currentValue.toFixed(2);
      if (progress < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function priceOf(groupKey, chosenValue) {
    if (!chosenValue) return 0;
    const list = PRICE_VARIANTS[groupKey] || [];
    const found = list.find((item) => item.value === chosenValue);
    return found ? found.price : 0;
  }

  function roundMoney(value) {
    return Math.round((Number(value) || 0) * 100) / 100;
  }

  function packOf(chosenValue) {
    return (
      PACK_VARIANTS.find((item) => item.value === chosenValue) ||
      PACK_VARIANTS[0]
    );
  }

  function getUnitPrice() {
    let total = 0;
    total += priceOf("size", state.size);
    total += priceOf("materialFinish", state.materialFinish);
    total += priceOf("enhanceImage", state.enhanceImage);
    total += priceOf("onlineProof", state.onlineProof);
    return roundMoney(total);
  }

  function calculatePackTotal(packSize = state.packSize) {
    const pack = packOf(packSize);
    return roundMoney(getUnitPrice() * pack.qty * (1 - pack.discount));
  }

  function updatePackSizePrices() {
    const unitPrice = getUnitPrice();
    document.querySelectorAll("#pack-size-variant .pcip17-pack-row").forEach((row) => {
      const pack = packOf(row.dataset.packSize);
      const total = roundMoney(unitPrice * pack.qty * (1 - pack.discount));
      const priceEl = row.querySelector(".pcip17-pack-price");
      if (priceEl) priceEl.textContent = `$${total.toFixed(2)}`;
      row.dataset.price = total.toFixed(2);
      row.dataset.packQty = String(pack.qty);
      row.dataset.discount = String(pack.discount);
    });
  }

  function recalcPrice() {
    const total = calculatePackTotal();

    const priceEl = document.getElementById("pcs-final-price");
    if (priceEl) {
      const prevValue = parseFloat(priceEl.textContent) || 0;
      if (prevValue !== total) {
        animatePriceChange(priceEl, prevValue, total);
      }
    }
    state.price = total;
    updatePackSizePrices();
  }

  function debounce(func, delay) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => func(...args), delay);
    };
  }

  function dataURLtoFile(dataurl, filename) {
    const arr = dataurl.split(",");
    const mime = arr[0].match(/:(.*?);/)?.[1] || "image/png";
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }

  function disableBodyScroll() {
    const scrollY = window.scrollY;
    document.body.style.position = "fixed";
    document.body.style.top = `-${scrollY}px`;
    document.body.style.left = "0";
    document.body.style.right = "0";
    document.body.dataset.scrollY = scrollY;
  }

  function enableBodyScroll() {
    const scrollY = document.body.dataset.scrollY || 0;
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.left = "";
    document.body.style.right = "";
    window.scrollTo(0, parseInt(scrollY, 10));
    document.body.removeAttribute("data-scrollY");
  }

  function findScrollableParent(el) {
    while (el) {
      const style = window.getComputedStyle(el);
      const overflow = style.overflow || style.overflowY;
      if ((overflow === "auto" || overflow === "scroll") && el.scrollHeight > el.clientHeight) {
        return el;
      }
      el = el.parentElement;
    }
    return document.documentElement;
  }

  function scrollToElement(element) {
    if (!element) return;
    const scroller = findScrollableParent(element);
    if (scroller && scroller !== document.documentElement) {
      const rectTarget = element.getBoundingClientRect();
      const rectScroller = scroller.getBoundingClientRect();
      const offset = rectTarget.top - rectScroller.top;
      const centering = scroller.clientHeight / 2 - rectTarget.height / 2;
      scroller.scrollTo({
        top: scroller.scrollTop + offset - centering,
        behavior: "smooth",
      });
    } else {
      element.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }

  function setError(id, shouldShow, message = "") {
    const el = document.getElementById(id);
    if (!el) return null;
    if (message) {
      const textTarget = el.querySelector("p") || el;
      textTarget.textContent = message;
    }
    el.style.display = shouldShow ? "block" : "none";
    el.classList.toggle("active", shouldShow);
    const variantBox = el.closest(".pcs-variant");
    if (variantBox) variantBox.classList.toggle("has-error", shouldShow);
    return shouldShow ? variantBox || el : null;
  }

  function clearError(id) {
    setError(id, false);
  }

  function blinkVariantElement(element) {
    if (!element) return;
    const blinkClass =
      element.classList.contains("artwork-box") || element.classList.contains("sticker-variant")
        ? "no-border-variant-blink"
        : "border-variant-blink";
    let blinkCount = 0;
    const intervalId = setInterval(() => {
      element.classList.toggle(blinkClass);
      blinkCount++;
      if (blinkCount >= 4) {
        clearInterval(intervalId);
        element.classList.remove(blinkClass);
      }
    }, 300);
  }

  function isAllowedImage(file) {
    if (!file) return false;
    const ext = (file.name.split(".").pop() || "").toLowerCase();
    const allowedExts = ["jpg", "jpeg", "png", "svg", "webp"];
    return ALLOWED_IMAGE_TYPES.includes(file.type) || allowedExts.includes(ext);
  }

  function loadFabricImage(url) {
    return new Promise((resolve, reject) => {
      if (!window.fabric?.Image?.fromURL) {
        reject(new Error("Fabric.js is not available."));
        return;
      }

      let settled = false;
      const finish = (img) => {
        if (settled) return;
        settled = true;
        if (img) resolve(img);
        else reject(new Error("Image failed to load."));
      };
      const fail = (err) => {
        if (settled) return;
        settled = true;
        reject(err instanceof Error ? err : new Error("Image failed to load."));
      };

      try {
        const maybePromise = fabric.Image.fromURL(
          url,
          (img) => finish(img),
          { crossOrigin: "anonymous" }
        );
        if (maybePromise && typeof maybePromise.then === "function") {
          maybePromise.then(finish).catch(fail);
        }
      } catch (err) {
        fail(err);
      }

      window.setTimeout(() => {
        if (!settled) fail(new Error("Image load timed out."));
      }, 15000);
    });
  }

  function typeText(element, text) {
    if (!element) return Promise.resolve();
    element.textContent = "";
    return new Promise((resolve) => {
      let i = 0;
      const interval = setInterval(() => {
        element.textContent += text.charAt(i);
        i++;
        if (i >= text.length) {
          clearInterval(interval);
          resolve();
        }
      }, 35);
    });
  }

  function deleteText(element) {
    if (!element) return Promise.resolve();
    return new Promise((resolve) => {
      const interval = setInterval(() => {
        element.textContent = element.textContent.slice(0, -1);
        if (!element.textContent.length) {
          clearInterval(interval);
          resolve();
        }
      }, 20);
    });
  }

  function setVariantActive(container, selected) {
    if (!container || !selected) return;
    container.querySelectorAll(".sticker-variant").forEach((el) => {
      const isActive = el === selected;
      el.classList.toggle("active", isActive);
      el.classList.toggle("selected", isActive);
      if (el.getAttribute("role") === "button") {
        el.setAttribute("aria-pressed", String(isActive));
      }
    });
  }

  function setupKeyboardVariantClicks() {
    document.querySelectorAll('#pcs-custom-fields [role="button"].sticker-variant').forEach((el) => {
      el.addEventListener("keydown", (event) => {
        if (event.key !== "Enter" && event.key !== " ") return;
        event.preventDefault();
        el.click();
      });
    });
  }

  function setupSizeSelection() {
    const sizeVariant = document.getElementById("size-variant");
    const artworkVariant = document.getElementById("artwork-variant");
    if (!sizeVariant) return;

    sizeVariant.addEventListener("click", (event) => {
      const selected = event.target.closest(".sticker-variant");
      if (!selected || !sizeVariant.contains(selected)) return;
      setVariantActive(sizeVariant, selected);
      state.size = selected.dataset.size || null;
      clearError("size-error-bar");
      if (artworkVariant) show(artworkVariant);
      recalcPrice();
      if (designer) designer.renderLayout();
    });
  }

  function setupPreviewSelection() {
    const variant = document.getElementById("iphone-preview-variant");
    if (!variant) return;

    variant.addEventListener("click", async (event) => {
      const selected = event.target.closest(".sticker-variant");
      if (!selected || !variant.contains(selected)) return;
      setVariantActive(variant, selected);
      state.iphonePreview = selected.dataset.preview || "Cosmic Orange";
      await designer?.updateMockup(getMockupUrlFromOption(selected));
    });
  }

  function setupMaterialSelection() {
    const variant = document.getElementById("material-variant");
    if (!variant) return;

    variant.addEventListener("click", (event) => {
      const selected = event.target.closest(".sticker-variant");
      if (!selected || !variant.contains(selected)) return;
      setVariantActive(variant, selected);
      state.materialFinish = selected.dataset.material || "Standard";
      clearError("material-error-bar");
      recalcPrice();
    });
  }

  function setupEnhanceSelection() {
    const variant = document.getElementById("enhance-variant");
    if (!variant) return;

    variant.addEventListener("click", (event) => {
      const selected = event.target.closest(".sticker-variant");
      if (!selected || !variant.contains(selected)) return;
      setVariantActive(variant, selected);
      state.enhanceImage = selected.dataset.enhance || "No, Keep Image as is";
      clearError("enhance-error-bar");
      recalcPrice();
    });
  }

  function setupProofSelection() {
    const variant = document.getElementById("online-proof-variant");
    if (!variant) return;

    variant.addEventListener("click", (event) => {
      const selected = event.target.closest(".sticker-variant");
      if (!selected || !variant.contains(selected)) return;
      setVariantActive(variant, selected);
      state.onlineProof = selected.dataset.proof || "Yes";
      clearError("proof-error-bar");
      recalcPrice();
    });
  }

  function setupPackSizeSelection() {
    const variant = document.getElementById("pack-size-variant");
    if (!variant) return;

    variant.addEventListener("click", (event) => {
      const selected = event.target.closest(".sticker-variant");
      if (!selected || !variant.contains(selected)) return;
      setVariantActive(variant, selected);
      state.packSize = selected.dataset.packSize || "Single";
      clearError("pack-size-error-bar");
      updatePackSizePrices();
      recalcPrice();
    });
  }

  function updateUploadPreview(file, dataUrl) {
    const artbox = document.getElementById("upload-artbox-image");
    const previewBox = document.getElementById("preview-box-image");
    const previewImg = document.getElementById("preview-image-image");
    const input = document.getElementById("upload-file-image");

    if (previewImg) previewImg.src = dataUrl;
    if (artbox) hide(artbox);
    if (previewBox) show(previewBox);
    if (input) input.dataset.fileName = file.name;
    clearError("upload-file-error-image");
  }

  function clearGeneratedPreview() {
    state.editedImage = null;
    const previewBox = document.getElementById("preview-box");
    const previewImg = document.getElementById("preview-image");
    const uploadArtbox = document.getElementById("upload-artbox");
    const packSizeVariant = document.getElementById("pack-size-variant");
    if (previewImg) previewImg.src = "";
    if (previewBox) hide(previewBox);
    if (uploadArtbox) show(uploadArtbox);
    if (packSizeVariant) hide(packSizeVariant);
    state.packSize = "Single";
    resetActiveVariant(
      "pack-size-variant",
      (option) => option.dataset.packSize === state.packSize
    );
    updatePackSizePrices();
    recalcPrice();
  }

  function resetActiveVariant(containerId, predicate) {
    const container = document.getElementById(containerId);
    if (!container) return;
    const options = container.querySelectorAll(".sticker-variant");
    options.forEach((option) => {
      const isActive = Boolean(predicate(option));
      option.classList.toggle("active", isActive);
      option.classList.toggle("selected", isActive);
      if (option.getAttribute("role") === "button") {
        option.setAttribute("aria-pressed", String(isActive));
      }
    });
  }

  function clearAllErrors() {
    document.querySelectorAll("#pcs-custom-fields .error-bar").forEach((bar) => {
      bar.style.display = "none";
      bar.classList.remove("active");
    });
    document.querySelectorAll("#pcs-custom-fields .error-message").forEach((message) => {
      message.textContent = "";
      message.style.display = "";
      message.classList.remove("active");
    });
    document.querySelectorAll("#pcs-custom-fields .pcs-variant").forEach((variant) => {
      variant.classList.remove("has-error");
    });
  }

  async function resetCustomizerAfterCart() {
    state.size = null;
    state.uploadedImage = null;
    state.uploadedImageUrl = null;
    state.uploadedImageTransform = null;
    state.editedImage = null;
    state.iphonePreview = "Cosmic Orange";
    state.materialFinish = "Standard";
    state.enhanceImage = "No, Keep Image as is";
    state.onlineProof = "Yes";
    state.packSize = "Single";
    state.price = 0;

    resetActiveVariant("size-variant", () => false);
    resetActiveVariant(
      "iphone-preview-variant",
      (option) => option.dataset.preview === state.iphonePreview
    );
    resetActiveVariant(
      "material-variant",
      (option) => option.dataset.material === state.materialFinish
    );
    resetActiveVariant(
      "enhance-variant",
      (option) => option.dataset.enhance === state.enhanceImage
    );
    resetActiveVariant(
      "online-proof-variant",
      (option) => option.dataset.proof === state.onlineProof
    );
    resetActiveVariant(
      "pack-size-variant",
      (option) => option.dataset.packSize === state.packSize
    );

    const artworkVariant = document.getElementById("artwork-variant");
    if (artworkVariant) hide(artworkVariant);
    const packSizeVariant = document.getElementById("pack-size-variant");
    if (packSizeVariant) hide(packSizeVariant);

    const uploadArtbox = document.getElementById("upload-artbox");
    const previewBox = document.getElementById("preview-box");
    const previewImg = document.getElementById("preview-image");
    if (uploadArtbox) show(uploadArtbox);
    if (previewBox) hide(previewBox);
    if (previewImg) previewImg.src = "";

    const fileInput = document.getElementById("upload-file-image");
    const sidebarUploadArtbox = document.getElementById("upload-artbox-image");
    const sidebarPreviewBox = document.getElementById("preview-box-image");
    const sidebarPreviewImg = document.getElementById("preview-image-image");
    if (fileInput) fileInput.value = "";
    if (sidebarUploadArtbox) show(sidebarUploadArtbox);
    if (sidebarPreviewBox) hide(sidebarPreviewBox);
    if (sidebarPreviewImg) sidebarPreviewImg.src = "";

    document.getElementById("close-tool-popup")?.classList.remove("active");
    document.getElementById("designerTool")?.classList.remove("active");
    if (document.body.style.position === "fixed" || document.body.dataset.scrollY) {
      enableBodyScroll();
    }

    const guidesToggle = document.getElementById("toggleGuides");
    const snapToggle = document.getElementById("toggleSnap");
    if (guidesToggle) guidesToggle.checked = true;
    if (snapToggle) snapToggle.checked = true;

    clearAllErrors();
    updatePackSizePrices();
    recalcPrice();
    await designer?.resetDesigner();
  }

  function bindUpload() {
    const fileInput = document.getElementById("upload-file-image");
    const chooseBtn = document.getElementById("choose-file-btn-image");
    const artbox = document.getElementById("upload-artbox-image");
    const previewBox = document.getElementById("preview-box-image");
    const previewImg = document.getElementById("preview-image-image");
    const deleteBtn = document.getElementById("delete-image");
    const errorMsg = document.getElementById("upload-file-error-image");
    const uploadZone = artbox?.closest(".pcip17-upload-zone");

    if (!fileInput || !chooseBtn || !artbox || !previewBox || !previewImg || !deleteBtn || !errorMsg) {
      return;
    }

    const processFile = (file) => {
      if (!file) return;
      if (!isAllowedImage(file)) {
        setError("upload-file-error-image", true, "Please upload .jpg, .jpeg, .png, .webp or .svg");
        fileInput.value = "";
        return;
      }

      const reader = new FileReader();
      reader.onload = async (event) => {
        const dataUrl = event.target.result;
        state.uploadedImage = file;
        state.uploadedImageUrl = dataUrl;
        state.uploadedImageTransform = null;
        clearGeneratedPreview();
        updateUploadPreview(file, dataUrl);
        await designer?.handleImageUpload(file, dataUrl);
      };
      reader.onerror = () => {
        setError("upload-file-error-image", true, "Error reading file. Please try again.");
      };
      reader.readAsDataURL(file);
    };

    chooseBtn.addEventListener("click", (event) => {
      event.preventDefault();
      fileInput.click();
    });

    fileInput.addEventListener("change", (event) => {
      processFile(event.target.files?.[0]);
    });

    ["dragenter", "dragover"].forEach((eventName) => {
      artbox.addEventListener(eventName, (event) => {
        event.preventDefault();
        uploadZone?.classList.add("is-dragover");
      });
    });

    ["dragleave", "drop"].forEach((eventName) => {
      artbox.addEventListener(eventName, (event) => {
        event.preventDefault();
        uploadZone?.classList.remove("is-dragover");
      });
    });

    artbox.addEventListener("drop", (event) => {
      processFile(event.dataTransfer?.files?.[0]);
    });

    deleteBtn.addEventListener("click", () => {
      fileInput.value = "";
      show(artbox);
      hide(previewBox);
      previewImg.src = "";
      clearError("upload-file-error-image");
      state.uploadedImage = null;
      state.uploadedImageUrl = null;
      state.uploadedImageTransform = null;
      clearGeneratedPreview();
      designer?.removeArtwork();
    });
  }

  function validateForm() {
    let firstInvalid = null;
    let missingUpload = false;

    const record = (element) => {
      if (element && !firstInvalid) firstInvalid = element;
    };

    record(setError("size-error-bar", !state.size, "Please select a phone model."));

    if (!state.uploadedImage && !state.uploadedImageUrl && !state.editedImage) {
      missingUpload = true;
      record(
        setError(
          "upload-file-error-image",
          true,
          "Please upload your artwork before adding to cart."
        )
      );
    } else {
      clearError("upload-file-error-image");
    }

    record(
      setError(
        "material-error-bar",
        !state.materialFinish,
        "Please select a material finish."
      )
    );
    record(
      setError(
        "enhance-error-bar",
        !state.enhanceImage,
        "Please select an image enhancement option."
      )
    );
    record(
      setError(
        "proof-error-bar",
        !state.onlineProof,
        "Please select an online proof option."
      )
    );
    record(
      setError(
        "pack-size-error-bar",
        !state.packSize,
        "Please select a pack size."
      )
    );

    if (firstInvalid) {
      const openAndScroll = async () => {
        if (missingUpload && state.size && designer) {
          await designer.open();
        }
        scrollToElement(firstInvalid);
        blinkVariantElement(firstInvalid);
      };
      openAndScroll();
      return false;
    }

    return true;
  }

  function buildCartButtonContent() {
    return `
      <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <circle cx="8" cy="21" r="1"></circle>
        <circle cx="19" cy="21" r="1"></circle>
        <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h8.78a2 2 0 0 0 1.95-1.57L21 7H5.12"></path>
      </svg>
      Add to Cart
    `;
  }

  async function refreshMiniCart(cartAddJson, shopifyVariantId) {
    localStorage.setItem(
      `patched-cart-item-${cartAddJson.id}`,
      JSON.stringify({
        id: cartAddJson.id,
        title: cartAddJson.product_title,
        image: cartAddJson.image,
        price: cartAddJson.price,
      })
    );

    const cartJson = {
      items: [cartAddJson],
      item_count: 1,
      total_price: cartAddJson.final_price,
      original_total_price: cartAddJson.original_price,
      total_discount: 0,
    };

    const timestamp = new Date().getTime();
    await new Promise((resolve) => setTimeout(resolve, 200));
    const sectionHtml = await fetch(`/cart?section_id=mini-cart&t=${timestamp}`).then((res) =>
      res.text()
    );
    const fakeDiv = document.createElement("div");
    fakeDiv.innerHTML = sectionHtml;
    const miniCartHTML = fakeDiv.querySelector("cart-drawer")?.outerHTML;
    const cartDrawer = document.querySelector("cart-drawer");

    if (cartDrawer && miniCartHTML) {
      cartDrawer.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true,
          detail: {
            cart: {
              ...cartJson,
              sections: {
                "mini-cart": miniCartHTML,
              },
            },
            openMiniCart: true,
          },
        })
      );
    }

    window.setTimeout(() => {
      if (!cartDrawer) return;
      const lineItems = cartDrawer.querySelectorAll("line-item");
      lineItems.forEach((lineItem) => {
        const desktopPriceContainer = lineItem.querySelector(
          ".line-item__price-list-container .price"
        );
        const mobilePriceContainer = lineItem.querySelector(
          ".product-item-meta__price-list-container .price-list.hidden-tablet-and-up .price"
        );
        if (!desktopPriceContainer && !mobilePriceContainer) return;

        const priceText = (desktopPriceContainer || mobilePriceContainer).textContent.trim();
        const isFree = /Free|\$0\.00/.test(priceText);
        let variantId;
        const productLink = lineItem.querySelector("a[href*='?variant=']");
        if (productLink?.href.includes("variant=")) {
          variantId = productLink.href.split("variant=")[1].split("&")[0];
        }
        if (!variantId) {
          const removeBtn = lineItem.querySelector("a[href*='/cart/change?id=']");
          const removeHref = removeBtn?.getAttribute("href") || "";
          const match = removeHref.match(/id=(\d+):/);
          variantId = match?.[1];
        }

        if (isFree && variantId == shopifyVariantId) {
          const matchingItem = cartJson.items.find((item) => String(item.id) === variantId);
          if (!matchingItem) return;
          const correctPrice = (matchingItem.price / 100).toFixed(2);
          const updatedPriceHTML = `
            <span class="visually-hidden">Sale price</span>
            $${correctPrice}
          `;
          if (desktopPriceContainer) desktopPriceContainer.innerHTML = updatedPriceHTML;
          if (mobilePriceContainer) mobilePriceContainer.innerHTML = updatedPriceHTML;
        }
      });
    }, 300);

    window.setTimeout(async () => {
      try {
        const latestCartJson = await fetch("/cart.js").then((res) => res.json());
        const cartCountEl = document.querySelector("cart-count");
        if (cartCountEl) {
          cartCountEl.textContent = latestCartJson.item_count;
        }
      } catch (err) {
        console.warn("Cart count refresh failed:", err);
      }
    }, 300);

    window.setTimeout(() => {
      const drawerContent = document.querySelector("#shopify-section-mini-cart .drawer__content");
      if (!drawerContent) return;
      const confetti = document.createElement("dotlottie-player");
      confetti.className = "mini-cart-lottie";
      confetti.src = "//cdn.shopify.com/s/files/1/0582/5400/0176/files/confetti.json?v=1748024242";
      confetti.setAttribute("background", "transparent");
      confetti.setAttribute("speed", "1");
      confetti.setAttribute("style", "width: 300px; height: 300px");
      confetti.setAttribute("direction", "1");
      confetti.setAttribute("playmode", "normal");
      confetti.setAttribute("autoplay", "");
      drawerContent.prepend(confetti);
      window.setTimeout(() => confetti.remove(), 3000);
    }, 1000);
  }

  function setupApippaAddToCart() {
    const addToCartBtn = document.getElementById("pcs-add-to-cart");
    if (!addToCartBtn) return;

    addToCartBtn.addEventListener("click", async (event) => {
      event.preventDefault();
      if (!validateForm()) return;

      addToCartBtn.disabled = true;
      addToCartBtn.classList.add("loading");
      addToCartBtn.innerHTML = `
        <div class="pcs-loader"></div>
        <p class="pcs-message"></p>
        <div class="dot-falling"></div>
      `;

      const messageEl = addToCartBtn.querySelector(".pcs-message");
      const messages = ["Adding to cart", "GETTING THINGS READY"];
      let messageIndex = 0;
      let stopTypingLoop = false;
      const startTypingLoop = async () => {
        while (!stopTypingLoop) {
          const message = messages[messageIndex % messages.length];
          await typeText(messageEl, message);
          await new Promise((resolve) => setTimeout(resolve, 1600));
          await deleteText(messageEl);
          messageIndex++;
        }
      };
      startTypingLoop();

      const loadingBar = addToCartBtn.querySelector(".pcs-loader");
      let progress = 0;
      const target = 99;
      const interval = setInterval(() => {
        if (progress < 50) {
          progress += 2;
        } else if (progress < 80) {
          progress += (80 - progress) * 0.05;
        } else if (progress < target - 0.2) {
          progress += (target - progress) * 0.05;
        } else {
          progress = target - 0.01;
          clearInterval(interval);
        }
        if (loadingBar) loadingBar.style.transform = `scaleX(${Math.floor(progress) / 100})`;
      }, 80);

      try {
        if (!state.editedImage && state.uploadedImageUrl) {
          const generated = await designer?.finishEditing({ closeDesigner: false });
          if (!generated) {
            throw new Error("Edited preview could not be generated.");
          }
        }

        recalcPrice();
        const selectedPack = packOf(state.packSize);

        const requestData = {
          calculatorId: APIPPA_CALCULATOR_ID,
          productId: SHOPIFY_PRODUCT_ID,
          properties: {
            "Phone Model": state.size,
            "Uploaded Image": state.uploadedImage?.name || "",
            "Edited Preview": state.editedImage?.name || "",
            "IPhone Preview": state.iphonePreview,
            "Material Finish": state.materialFinish,
            "Enhance Image": state.enhanceImage,
            "Online Proof": state.onlineProof,
            "Pack Size": state.packSize,
            "Pack Quantity": String(selectedPack.qty),
            "Pack Discount": `${Math.round(selectedPack.discount * 100)}%`,
            "Unit Price": `$${getUnitPrice().toFixed(2)}`,
            "Pack Total": `$${state.price.toFixed(2)}`,
          },
        };

        console.log("Apippa Add to Cart Request Data:", requestData);

        const variantRes = await fetch("https://api.custompricecalculator.com/api/v1/variant", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestData),
        });
        const variantId = await variantRes.json();
        const shopifyVariantId =
          typeof variantId === "string" ? variantId : variantId?.variantId || variantId?.id;
        if (!shopifyVariantId) throw new Error("Invalid variant ID");

        const formData = new FormData();
        formData.append("id", shopifyVariantId);
        formData.append("quantity", 1);
        Object.entries(requestData.properties).forEach(([key, value]) => {
          formData.append(`properties[${key}]`, value);
        });
        if (state.uploadedImage) {
          formData.append("properties[Uploaded Image]", state.uploadedImage);
        }
        if (state.editedImage) {
          formData.append("properties[Edited Preview]", state.editedImage);
        }

        const cartAddRes = await fetch("/cart/add.js", {
          method: "POST",
          body: formData,
        });
        const cartAddJson = await cartAddRes.json();
        if (!cartAddRes.ok) throw new Error("Failed to add to cart");

        await refreshMiniCart(cartAddJson, shopifyVariantId);
        try {
          await resetCustomizerAfterCart();
        } catch (resetErr) {
          console.warn("Customizer reset failed after cart add:", resetErr);
        }
      } catch (err) {
        console.error("Apippa Add to Cart Error:", err);
        alert("There was a problem adding your item to the cart.");
      } finally {
        clearInterval(interval);
        stopTypingLoop = true;
        addToCartBtn.disabled = false;
        addToCartBtn.classList.remove("loading");
        addToCartBtn.innerHTML = buildCartButtonContent();
      }
    });
  }

  class IPhoneSkinWrapDesigner {
    constructor() {
      this.canvas = null;
      this.clipPath = null;
      this.artworkImage = null;
      this.mockupImage = null;
      this.guideObjects = [];
      this.snappingEnabled = true;
      this._renderToken = 0;
      this._resizeObserver = null;
      this.currentMockupFile = DEFAULT_MOCKUP;
      this.mockupSource = { width: 1673, height: 3452 };
      this.lastLayout = null;
      this.init();
    }

    init() {
      const canvasContainer = document.getElementById("canvasContainer");
      if (!canvasContainer) return;

      if (!window.fabric) {
        this.showError("Fabric.js is required for the designer.");
        return;
      }

      canvasContainer.innerHTML = '<canvas id="stickerCanvas"></canvas>';
      this.canvas = new fabric.Canvas("stickerCanvas", {
        width: Math.max(canvasContainer.clientWidth || 1, 1),
        height: Math.max(canvasContainer.clientHeight || 1, 1),
        preserveObjectStacking: true,
        controlsAboveOverlay: true,
        selection: true,
        backgroundColor: "white",
      });

      this.setupFabricDefaults();
      this.setupEventListeners();
      this.observeContainerResize(canvasContainer);
      this.updateCanvasSize();
      this.loadMockup(getSelectedPreviewMockupUrl());
    }

    setupFabricDefaults() {
      if (!window.fabric?.Object) return;
      fabric.Object.prototype.transparentCorners = false;
      fabric.Object.prototype.cornerColor = "#111114";
      fabric.Object.prototype.borderColor = "#111114";
      fabric.Object.prototype.cornerStyle = "circle";
      fabric.Object.prototype.cornerStrokeColor = "#ffffff";
      fabric.Object.prototype.borderScaleFactor = 1;
    }

    setupEventListeners() {
      window.addEventListener("resize", debounce(() => this.handleResize(), 250));

      const getStartedBtn = document.getElementById("get-started-btn");
      if (getStartedBtn) {
        getStartedBtn.addEventListener("click", async () => {
          if (!state.size) {
            const err = setError("size-error-bar", true, "Please select a phone model.");
            scrollToElement(err || document.getElementById("size-variant"));
            return;
          }
          await this.open();
        });
      }

      const btnEditImage = document.getElementById("btnEditImage");
      if (btnEditImage) {
        btnEditImage.addEventListener("click", async () => this.open());
      }

      const closeBtn = document.getElementById("designer-tool-close-btn");
      if (closeBtn) {
        closeBtn.addEventListener("click", () => {
          document.getElementById("close-tool-popup")?.classList.add("active");
        });
      }

      const cancelClose = document.getElementById("cancel-close-tool");
      if (cancelClose) {
        cancelClose.addEventListener("click", () => {
          document.getElementById("close-tool-popup")?.classList.remove("active");
        });
      }

      const confirmClose = document.getElementById("confirm-close-tool");
      if (confirmClose) {
        confirmClose.addEventListener("click", () => {
          document.getElementById("close-tool-popup")?.classList.remove("active");
          this.close();
        });
      }

      const toggleGuides = document.getElementById("toggleGuides");
      if (toggleGuides) {
        toggleGuides.addEventListener("change", (event) => {
          this.toggleGuidelines(event.target.checked);
        });
      }

      const toggleSnap = document.getElementById("toggleSnap");
      if (toggleSnap) {
        toggleSnap.addEventListener("change", (event) => {
          this.snappingEnabled = event.target.checked;
        });
      }

      document.querySelectorAll(".align-btn").forEach((btn) => {
        btn.addEventListener("click", (event) => {
          this.alignObjects(event.currentTarget.dataset.align);
        });
      });

      const finishEditing = document.getElementById("finishEditing");
      if (finishEditing) {
        finishEditing.addEventListener("click", () => this.finishEditing());
      }

      if (!this.canvas) return;

      this.canvas.on("object:moving", (event) => this.handleObjectMoving(event));
      this.canvas.on("object:modified", () => this.saveArtworkTransform());
      this.canvas.on("object:scaling", () => this.saveArtworkTransform());
      this.canvas.on("object:rotating", () => this.saveArtworkTransform());
      this.canvas.on("object:added", () => this.bringGuidesToFront());
      this.canvas.on("selection:created", () => this.scrollToUploadField());
      this.canvas.on("selection:updated", () => this.scrollToUploadField());
    }

    observeContainerResize(container) {
      if (!window.ResizeObserver || !container) return;
      const observer = new ResizeObserver(debounce(() => this.handleResize(), 120));
      observer.observe(container);
      this._resizeObserver = observer;
    }

    async open() {
      const designerTool = document.getElementById("designerTool");
      if (!designerTool) return;
      designerTool.classList.add("active");
      disableBodyScroll();
      await new Promise((resolve) => requestAnimationFrame(() => requestAnimationFrame(resolve)));
      this.updateCanvasSize();
      await this.renderFromState();
      const imageVariant = document.getElementById("image-variant");
      if (imageVariant && !state.uploadedImageUrl) scrollToElement(imageVariant);
    }

    close() {
      const designerTool = document.getElementById("designerTool");
      if (designerTool) designerTool.classList.remove("active");
      enableBodyScroll();
    }

    updateCanvasSize() {
      const container = document.getElementById("canvasContainer");
      if (!container || !this.canvas) return;
      const width = Math.max(1, container.clientWidth || 1);
      const height = Math.max(1, container.clientHeight || 1);
      this.canvas.setDimensions({ width, height });
      this.canvas.calcOffset();
      this.renderLayout();
    }

    getPhoneScaleAdjustment() {
      return state.size === "IPhone 17 Pro" ? 0.94 : 1;
    }

    calculateLayout() {
      if (!this.canvas) return null;
      const canvasWidth = this.canvas.getWidth();
      const canvasHeight = this.canvas.getHeight();
      const sourceWidth = this.mockupImage?.width || this.mockupSource.width;
      const sourceHeight = this.mockupImage?.height || this.mockupSource.height;
      const small = window.matchMedia("(max-width: 640px)").matches;
      const maxPhoneWidth = canvasWidth * (small ? 0.72 : 0.48);
      const maxPhoneHeight = canvasHeight * (small ? 0.88 : 0.9);
      const scale =
        Math.min(maxPhoneWidth / sourceWidth, maxPhoneHeight / sourceHeight) *
        this.getPhoneScaleAdjustment();
      const phoneWidth = sourceWidth * scale;
      const phoneHeight = sourceHeight * scale;
      const phoneLeft = (canvasWidth - phoneWidth) / 2;
      const phoneTop = (canvasHeight - phoneHeight) / 2;

      const skin = {
        left: phoneLeft + phoneWidth * 0.055,
        top: phoneTop + phoneHeight * 0.022,
        width: phoneWidth * 0.89,
        height: phoneHeight * 0.954,
        rx: phoneWidth * 0.09,
        ry: phoneWidth * 0.09,
      };

      return {
        phone: {
          left: phoneLeft,
          top: phoneTop,
          width: phoneWidth,
          height: phoneHeight,
          scale,
        },
        skin,
      };
    }

    renderLayout() {
      if (!this.canvas) return;
      const currentTransform = this.artworkImage ? this._snapshotObj(this.artworkImage) : null;
      const layout = this.calculateLayout();
      if (!layout) return;
      this.lastLayout = layout;

      this.clipPath = new fabric.Rect({
        left: layout.skin.left,
        top: layout.skin.top,
        width: layout.skin.width,
        height: layout.skin.height,
        rx: layout.skin.rx,
        ry: layout.skin.ry,
        absolutePositioned: true,
      });

      if (this.mockupImage) {
        this.mockupImage.set({
          left: layout.phone.left,
          top: layout.phone.top,
          scaleX: layout.phone.scale,
          scaleY: layout.phone.scale,
          originX: "left",
          originY: "top",
          selectable: false,
          evented: false,
          hasControls: false,
          hasBorders: false,
        });
        this.mockupImage.setCoords();
        if (!this.canvas.getObjects().includes(this.mockupImage)) {
          this.canvas.add(this.mockupImage);
        }
      }

      if (this.artworkImage) {
        this.artworkImage.set({ clipPath: this.clipPath });
        const transform = state.uploadedImageTransform || currentTransform;
        if (transform) {
          this._applySnapshot(this.artworkImage, transform);
        } else {
          this.placeArtworkToCover(this.artworkImage);
        }
        if (!this.canvas.getObjects().includes(this.artworkImage)) {
          this.canvas.add(this.artworkImage);
        }
      }

      this.drawGuides(layout);
      this.orderLayers();
      this.canvas.requestRenderAll();
      this.updateFinishButtonState();
    }

    async renderFromState() {
      if (!this.canvas) return;
      const token = ++this._renderToken;
      this.canvas.clear();
      this.canvas.backgroundColor = "white";
      this.artworkImage = null;
      this.mockupImage = null;
      this.guideObjects = [];
      this.clipPath = null;

      await this.loadMockup(getSelectedPreviewMockupUrl(), token);
      if (token !== this._renderToken) return;

      if (state.uploadedImageUrl) {
        try {
          const img = await loadFabricImage(state.uploadedImageUrl);
          if (token !== this._renderToken) return;
          this.artworkImage = img;
          this.configureArtwork(img);
          this.canvas.add(img);
          this.renderLayout();
        } catch (err) {
          console.error("Artwork render failed:", err);
          this.showError("Failed to load the uploaded artwork.");
        }
      }

      this.renderLayout();
      this.updateFinishButtonState();
    }

    async loadMockup(mockupFile = DEFAULT_MOCKUP, token = this._renderToken) {
      if (!this.canvas) return;
      const file = mockupFile || DEFAULT_MOCKUP;
      this.currentMockupFile = file;
      const url = resolveAssetUrl(file);

      try {
        const img = await loadFabricImage(url);
        if (token !== this._renderToken) return;
        if (this.mockupImage && this.canvas.getObjects().includes(this.mockupImage)) {
          this.canvas.remove(this.mockupImage);
        }
        this.mockupSource = { width: img.width || 1673, height: img.height || 3452 };
        this.mockupImage = img;
        this.mockupImage.set({
          selectable: false,
          evented: false,
          originX: "left",
          originY: "top",
        });
        this.canvas.add(this.mockupImage);
        this.renderLayout();
      } catch (err) {
        console.error("Mockup load failed:", err);
        this.showError("Failed to load the iPhone preview mockup.");
      }
    }

    async updateMockup(mockupFile) {
      if (!this.canvas) return;
      this.saveArtworkTransform();
      const token = ++this._renderToken;
      await this.loadMockup(mockupFile || DEFAULT_MOCKUP, token);
      if (this.artworkImage) {
        this.canvas.setActiveObject(this.artworkImage);
      }
      this.renderLayout();
    }

    configureArtwork(img) {
      img.set({
        selectable: true,
        evented: true,
        hasControls: true,
        hasBorders: true,
        originX: "center",
        originY: "center",
        clipPath: this.clipPath,
      });
      img.setCoords();
    }

    placeArtworkToCover(img) {
      if (!img || !this.clipPath) return;
      const bounds = this.clipPath.getBoundingRect(true);
      const scale = Math.max(bounds.width / img.width, bounds.height / img.height);
      img.set({
        scaleX: scale,
        scaleY: scale,
        left: bounds.left + bounds.width / 2,
        top: bounds.top + bounds.height / 2,
        originX: "center",
        originY: "center",
      });
      img.setCoords();
    }

    async handleImageUpload(file, dataUrl) {
      if (!this.canvas) return;
      try {
        if (!document.getElementById("designerTool")?.classList.contains("active")) {
          await this.open();
        }
        const token = ++this._renderToken;
        const img = await loadFabricImage(dataUrl);
        if (token !== this._renderToken) return;
        if (this.artworkImage && this.canvas.getObjects().includes(this.artworkImage)) {
          this.canvas.remove(this.artworkImage);
        }
        this.artworkImage = img;
        this.configureArtwork(img);
        this.canvas.add(img);
        this.renderLayout();
        this.placeArtworkToCover(img);
        this.saveArtworkTransform();
        this.orderLayers();
        this.canvas.setActiveObject(img);
        this.canvas.requestRenderAll();
        this.updateFinishButtonState();
      } catch (err) {
        console.error("Image upload failed:", err);
        setError("upload-file-error-image", true, "Failed to place the uploaded image.");
      }
    }

    removeArtwork() {
      if (!this.canvas) return;
      if (this.artworkImage && this.canvas.getObjects().includes(this.artworkImage)) {
        this.canvas.remove(this.artworkImage);
      }
      this.artworkImage = null;
      state.uploadedImageTransform = null;
      this.renderLayout();
      this.updateFinishButtonState();
    }

    async resetDesigner() {
      if (!this.canvas) return;
      this.snappingEnabled = true;
      this.canvas.discardActiveObject();
      this.canvas.clear();
      this.canvas.backgroundColor = "white";
      this.clipPath = null;
      this.artworkImage = null;
      this.mockupImage = null;
      this.guideObjects = [];
      this.lastLayout = null;
      this._renderToken++;
      this.updateCanvasSize();
      await this.loadMockup(getSelectedPreviewMockupUrl(), this._renderToken);
      this.updateFinishButtonState();
      this.canvas.requestRenderAll();
    }

    drawGuides(layout) {
      if (!this.canvas || !layout) return;
      this.guideObjects.forEach((obj) => this.canvas.remove(obj));
      this.guideObjects = [];

      const shouldShow = document.getElementById("toggleGuides")?.checked ?? true;
      if (!shouldShow) return;

      const { left, top, width, height, rx, ry } = layout.skin;
      const centerX = left + width / 2;
      const centerY = top + height / 2;
      const guideColor = "#ec008c";

      const mainGuide = new fabric.Rect({
        left,
        top,
        width,
        height,
        rx,
        ry,
        fill: "transparent",
        stroke: guideColor,
        strokeWidth: 1.5,
        strokeDashArray: [8, 5],
        selectable: false,
        evented: false,
        strokeUniform: true,
      });

      const verticalGuide = new fabric.Line([centerX, top, centerX, top + height], {
        stroke: guideColor,
        strokeWidth: 1,
        strokeDashArray: [4, 8],
        opacity: 0.3,
        selectable: false,
        evented: false,
        strokeUniform: true,
      });

      const horizontalGuide = new fabric.Line([left, centerY, left + width, centerY], {
        stroke: guideColor,
        strokeWidth: 1,
        strokeDashArray: [4, 8],
        opacity: 0.3,
        selectable: false,
        evented: false,
        strokeUniform: true,
      });

      this.addGuideObject(mainGuide);
      this.addGuideObject(verticalGuide);
      this.addGuideObject(horizontalGuide);
      this.drawCornerHandles(layout);
    }

    drawCornerHandles(layout) {
      const { left, top, width, height } = layout.skin;
      const length = Math.min(30, width * 0.09);
      const inset = 5;
      const stroke = "#ec008c";
      const strokeWidth = 3;
      const points = [
        [
          [left + inset, top + inset, left + inset + length, top + inset],
          [left + inset, top + inset, left + inset, top + inset + length],
        ],
        [
          [left + width - inset, top + inset, left + width - inset - length, top + inset],
          [left + width - inset, top + inset, left + width - inset, top + inset + length],
        ],
        [
          [left + inset, top + height - inset, left + inset + length, top + height - inset],
          [left + inset, top + height - inset, left + inset, top + height - inset - length],
        ],
        [
          [
            left + width - inset,
            top + height - inset,
            left + width - inset - length,
            top + height - inset,
          ],
          [
            left + width - inset,
            top + height - inset,
            left + width - inset,
            top + height - inset - length,
          ],
        ],
      ];

      points.flat().forEach((coords) => {
        this.addGuideObject(
          new fabric.Line(coords, {
            stroke,
            strokeWidth,
            selectable: false,
            evented: false,
            strokeUniform: true,
          })
        );
      });
    }

    addGuideObject(obj) {
      this.guideObjects.push(obj);
      this.canvas.add(obj);
    }

    bringGuidesToFront() {
      if (!this.canvas || !this.guideObjects.length) return;
      this.guideObjects.forEach((guide) => {
        if (this.canvas.getObjects().includes(guide)) {
          this.canvas.bringToFront(guide);
        }
      });
      this.canvas.requestRenderAll();
    }

    orderLayers() {
      if (!this.canvas) return;
      if (this.artworkImage) this.canvas.sendToBack(this.artworkImage);
      if (this.mockupImage) this.canvas.bringToFront(this.mockupImage);
      this.bringGuidesToFront();
    }

    toggleGuidelines(visible) {
      if (!this.canvas) return;
      this.guideObjects.forEach((obj) => {
        obj.visible = visible;
        obj.set({ visible });
      });
      this.canvas.requestRenderAll();
    }

    handleObjectMoving(event) {
      if (!this.snappingEnabled || !this.clipPath || !event.target) return;
      const obj = event.target;
      if (obj !== this.artworkImage) return;

      const threshold = 10;
      const bounds = this.clipPath.getBoundingRect(true);
      const objBounds = obj.getBoundingRect(true);
      const center = obj.getCenterPoint();
      let targetX = center.x;
      let targetY = center.y;
      const clipCenterX = bounds.left + bounds.width / 2;
      const clipCenterY = bounds.top + bounds.height / 2;

      if (Math.abs(center.x - clipCenterX) <= threshold) targetX = clipCenterX;
      if (Math.abs(center.y - clipCenterY) <= threshold) targetY = clipCenterY;
      if (Math.abs(objBounds.left - bounds.left) <= threshold) {
        targetX += bounds.left - objBounds.left;
      }
      if (Math.abs(objBounds.left + objBounds.width - (bounds.left + bounds.width)) <= threshold) {
        targetX += bounds.left + bounds.width - (objBounds.left + objBounds.width);
      }
      if (Math.abs(objBounds.top - bounds.top) <= threshold) {
        targetY += bounds.top - objBounds.top;
      }
      if (Math.abs(objBounds.top + objBounds.height - (bounds.top + bounds.height)) <= threshold) {
        targetY += bounds.top + bounds.height - (objBounds.top + objBounds.height);
      }

      obj.setPositionByOrigin(new fabric.Point(targetX, targetY), "center", "center");
      obj.setCoords();
      this.canvas.requestRenderAll();
    }

    alignObjects(direction) {
      if (!this.canvas || !this.clipPath) return;
      const activeObjects = this.canvas.getActiveObjects().filter((obj) => obj === this.artworkImage);
      if (!activeObjects.length) return;

      const bounds = this.clipPath.getBoundingRect(true);
      activeObjects.forEach((obj) => {
        switch (direction) {
          case "left":
            obj.set({ left: bounds.left + obj.getScaledWidth() / 2 });
            break;
          case "centerH":
            obj.set({ left: bounds.left + bounds.width / 2 });
            break;
          case "right":
            obj.set({ left: bounds.left + bounds.width - obj.getScaledWidth() / 2 });
            break;
          case "top":
            obj.set({ top: bounds.top + obj.getScaledHeight() / 2 });
            break;
          case "centerV":
            obj.set({ top: bounds.top + bounds.height / 2 });
            break;
          case "bottom":
            obj.set({ top: bounds.top + bounds.height - obj.getScaledHeight() / 2 });
            break;
        }
        obj.setCoords();
      });

      this.saveArtworkTransform();
      this.canvas.requestRenderAll();
    }

    _snapshotObj(obj) {
      if (!obj || !this.clipPath) return null;
      const bounds = this.clipPath.getBoundingRect(true);
      return {
        cx: (obj.left - bounds.left) / bounds.width,
        cy: (obj.top - bounds.top) / bounds.height,
        scaleX: obj.scaleX,
        scaleY: obj.scaleY,
        angle: obj.angle || 0,
        originX: obj.originX || "center",
        originY: obj.originY || "center",
        clipW: bounds.width,
        clipH: bounds.height,
      };
    }

    _applySnapshot(obj, snap) {
      if (!obj || !snap || !this.clipPath) return;
      const bounds = this.clipPath.getBoundingRect(true);
      const kx = bounds.width / (snap.clipW || bounds.width);
      const ky = bounds.height / (snap.clipH || bounds.height);
      obj.set({
        left: bounds.left + snap.cx * bounds.width,
        top: bounds.top + snap.cy * bounds.height,
        originX: snap.originX,
        originY: snap.originY,
        scaleX: (snap.scaleX || 1) * kx,
        scaleY: (snap.scaleY || 1) * ky,
        angle: snap.angle || 0,
      });
      obj.setCoords();
    }

    saveArtworkTransform() {
      if (!this.artworkImage) return;
      state.uploadedImageTransform = this._snapshotObj(this.artworkImage);
    }

    hasContent() {
      return Boolean(state.uploadedImageUrl && this.artworkImage);
    }

    updateFinishButtonState() {
      const finishEditing = document.getElementById("finishEditing");
      if (finishEditing) finishEditing.disabled = !state.uploadedImageUrl;
    }

    exportPreviewPng(multiplier = 2) {
      if (!this.canvas) return "";
      const layout = this.lastLayout || this.calculateLayout();
      if (!layout) return "";
      const pad = 18;
      const left = Math.max(0, layout.phone.left - pad);
      const top = Math.max(0, layout.phone.top - pad);
      const right = Math.min(this.canvas.getWidth(), layout.phone.left + layout.phone.width + pad);
      const bottom = Math.min(this.canvas.getHeight(), layout.phone.top + layout.phone.height + pad);
      return this.canvas.toDataURL({
        left,
        top,
        width: Math.max(1, right - left),
        height: Math.max(1, bottom - top),
        format: "png",
        multiplier,
        enableRetinaScaling: true,
      });
    }

    async finishEditing(options = {}) {
      const { closeDesigner = true } = options;
      if (!this.canvas || !state.uploadedImageUrl) {
        this.showError("Please upload your artwork before finishing.");
        return false;
      }

      if (!this.artworkImage) {
        await this.renderFromState();
      }

      if (!this.artworkImage) {
        this.showError("Please upload your artwork before finishing.");
        return false;
      }

      this.saveArtworkTransform();
      const activeObject = this.canvas.getActiveObject();
      const guidesVisible = document.getElementById("toggleGuides")?.checked ?? true;

      try {
        this.canvas.discardActiveObject();
        this.guideObjects.forEach((guide) => {
          guide.visible = false;
          guide.set({ visible: false });
        });
        this.orderLayers();
        this.canvas.renderAll();

        const dataUrl = this.exportPreviewPng();
        if (!dataUrl) throw new Error("Preview export failed.");

        state.editedImage = dataURLtoFile(dataUrl, "iphone-17-skin-wrap-preview.png");
        const previewImage = document.getElementById("preview-image");
        const previewBox = document.getElementById("preview-box");
        const uploadArtbox = document.getElementById("upload-artbox");
        const packSizeVariant = document.getElementById("pack-size-variant");
        if (previewImage) previewImage.src = dataUrl;
        if (previewBox) show(previewBox);
        if (uploadArtbox) hide(uploadArtbox);
        if (packSizeVariant) {
          show(packSizeVariant);
          updatePackSizePrices();
        }
        if (closeDesigner) this.close();
        return true;
      } catch (err) {
        console.error("Error saving edited image:", err);
        this.showError("Failed to save edited image. Please try again.");
        return false;
      } finally {
        this.guideObjects.forEach((guide) => {
          guide.visible = guidesVisible;
          guide.set({ visible: guidesVisible });
        });
        if (activeObject && this.canvas.getObjects().includes(activeObject)) {
          this.canvas.setActiveObject(activeObject);
        }
        this.canvas.renderAll();
      }
    }

    handleResize() {
      if (!this.canvas) return;
      this.saveArtworkTransform();
      this.updateCanvasSize();
      this.canvas.requestRenderAll();
    }

    scrollToUploadField() {
      if (!this.canvas?.getActiveObject() || this.canvas.getActiveObject() !== this.artworkImage) return;
      const target = document.getElementById("image-variant");
      if (target) scrollToElement(target);
    }

    showError(message) {
      const msgEl = document.getElementById("canvasMessage");
      if (!msgEl) return;
      msgEl.classList.remove("warning");
      msgEl.classList.add("error");
      msgEl.textContent = message;
      show(msgEl);
      window.setTimeout(() => {
        msgEl.textContent = "";
        hide(msgEl);
      }, 5000);
    }

    showWarning(message) {
      const msgEl = document.getElementById("canvasMessage");
      if (!msgEl) return;
      msgEl.classList.remove("error");
      msgEl.classList.add("warning");
      msgEl.textContent = message;
      show(msgEl);
      window.setTimeout(() => {
        msgEl.textContent = "";
        hide(msgEl);
      }, 5000);
    }
  }

  function setupPreviewDeletion() {
    const deletePreview = document.getElementById("delete-banner-image");
    if (!deletePreview) return;
    deletePreview.addEventListener("click", () => {
      clearGeneratedPreview();
      designer?.removeArtwork();
      state.uploadedImage = null;
      state.uploadedImageUrl = null;
      state.uploadedImageTransform = null;

      const fileInput = document.getElementById("upload-file-image");
      const artbox = document.getElementById("upload-artbox-image");
      const previewBox = document.getElementById("preview-box-image");
      const previewImg = document.getElementById("preview-image-image");
      if (fileInput) fileInput.value = "";
      if (artbox) show(artbox);
      if (previewBox) hide(previewBox);
      if (previewImg) previewImg.src = "";
    });
  }

  function initializeActiveButtonStates() {
    document.querySelectorAll('#pcs-custom-fields [role="button"].sticker-variant').forEach((el) => {
      el.setAttribute("aria-pressed", String(el.classList.contains("active")));
    });
  }

  function initialize() {
    designer = new IPhoneSkinWrapDesigner();
    setupKeyboardVariantClicks();
    initializeActiveButtonStates();
    setupSizeSelection();
    setupPreviewSelection();
    setupMaterialSelection();
    setupEnhanceSelection();
    setupProofSelection();
    setupPackSizeSelection();
    bindUpload();
    setupPreviewDeletion();
    setupApippaAddToCart();
    recalcPrice();
  }

  initialize();
});
